import * as React from "react";
import { useSelector, shallowEqual } from "react-redux";
import { useLocation } from "react-router-dom";
import { ACCOUNT_LOGIN_ROUTE, VIEW_MENU_ROUTE } from "shared/constants/routes";
import { selectSignIn } from "states/global-value/global-value.slice";
import "./layout.less";
import { useEffect } from "react";
export interface ILayoutMenuPageProps {
  children?:
  | JSX.Element
  | JSX.Element[]
  | React.ReactChild
  | React.ReactChild[]
  | React.ReactNode;
}

export const LayoutPage = (props: ILayoutMenuPageProps) => {
  const isLogged = useSelector(selectSignIn, shallowEqual);
  const location = useLocation();
  const isUnAuthPath = [VIEW_MENU_ROUTE, ACCOUNT_LOGIN_ROUTE];

  const { children } = props;

  useEffect(() => {
    // if (!isLogged && !isUnAuthPath.includes(location.pathname)) {
    //   window.location.href =
    //     ACCOUNT_LOGIN_ROUTE + "?callback=" + location.pathname;
    // }
  }, [isLogged, location]);

  return (
    <div className="main-page bg-gray-50">
      <div className="container mx-auto lg:px-4">{children}</div>
    </div>
  );
};
export default LayoutPage;
